import * as React from "react";
const SvgFiRrShieldDog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.571 2.126 12.312.051a1 1 0 0 0-.63 0L5.424 2.126a4.99 4.99 0 0 0-3.427 4.746v5.171c0 6.563 7.005 10.577 9.153 11.65 0 0 .48.307.85.307.4 0 .964-.311 1.061-.352 2.422-1.026 8.937-4.457 8.937-11.605V6.872a4.99 4.99 0 0 0-3.427-4.746m1.427 9.917c0 6.181-6.088 9.11-7.954 9.861-1.888-.944-8.047-4.445-8.047-9.861V6.872c0-1.296.826-2.44 2.056-2.848l5.944-1.971 5.945 1.971a3 3 0 0 1 2.056 2.848zM15.996 9.5c-.387 0-.946-.253-1.268-.738C13.998 7.658 12.693 7 11.242 7H11V5.21a.708.708 0 0 0-.979-.654 2.5 2.5 0 0 0-1.52 2.302v.895l-1.578 2.983c-.468.934-.55 2.002-.225 2.931.577 1.649 1.983 3.066 3.062 3.964a1.5 1.5 0 0 0 1.404.279c.48-.151.844-.531.977-1.015l.52-1.894h1.642c1.684 0 3.157-1.112 3.584-2.704.272-1.017-.003-1.663-.28-2.026-.563-.733-1.44-.77-1.61-.77zm-.04 2.279c-.194.719-.873 1.221-1.653 1.221H11.9a1 1 0 0 0-.964.735l-.5 1.822c-.926-.875-1.573-1.763-1.849-2.551-.147-.421-.1-.922.115-1.355l1.402-2.65h1.14c.768 0 1.465.333 1.82.867.655.992 1.808 1.633 2.934 1.633v-.054s.023.093-.04.333z"
    />
  </svg>
);
export default SvgFiRrShieldDog;
